import {combineReducers} from "redux"
import classroom from './classroom'
import audioPlayer from './audioPlayer'
import profile from './profile'
import audioRecorder from './audioRecorder'
import account from './account'
import messageList from './messageList'
import popupList from './popupList'
import wechat from './wechat'
//import invitationCard from './invitationCard'
import chatroom from './chatroom'
import pay from './pay'
import followLiveroom from './followLiveroom'
import videoPlayer from './videoPlayer'
import discussList from './discussList'
import redpack from './redpack'
import checkin from './checkin'
import subscribeLecture from './subscribeLecture'
import subscribeChannel from './subscribeChannel'
import audioArea from './audioArea'
import ppt from './ppt'
import stats from './stats'
import component from './component'
import lecture from './lecture'
import error from './error'
import sharecard from './sharecard'
import channel from './channel'
import gift from './gift'
import liveroom from './liveroom'
import record from './record'
import customerservice from './customerservice'
import transactionRecord from './transactionRecord'
import dataCenter from './dataCenter'
import dataCenterDetail from './dataCenterDetail'
import discount from './discount'
import activity from './activity'
import walletLiveroomIncome from './walletLiveroomIncome'
import walletExtensionIncome from './walletExtensionIncome'
import wk from './wk'
import main from './main'
import listenermanage from './listenermanage'
import search from './search'
import liveroomSettingLecture from './liveroomSettingLecture'
import liveroomSetting from './liveroomSetting'
import coupon from './coupon'
import relaySetting from './relaySetting'
import relay from './relays'
import relayConfirm from './relayConfirm'
import walletDetail from './walletDetail'
import lecturerInvite from './lecturerInvite'
import newCoupon from './newCoupon'
import robot from './robot'
import schedule from './schedule'
import details from './details'
import imagePreviewer from './imagePreviewer'
import global_component from './global_component'


export default combineReducers({
    classroom,
    audioPlayer,
    profile,
    audioRecorder,
    account,
    messageList,
    popupList,
    wechat,
    //invitationCard,
    chatroom,
    pay,
    followLiveroom,
    videoPlayer,
    discussList,
    redpack,
    checkin,
    subscribeLecture,
    subscribeChannel,
    audioArea,
    ppt,
    stats,
    component,
    lecture,
    error,
    sharecard,
    channel,
    gift,
    liveroom,
    record,
    customerservice,
    transactionRecord,
    dataCenter,
    dataCenterDetail,
    discount,
    activity,
    walletLiveroomIncome,
    walletExtensionIncome,
    wk,
    main,
    listenermanage,
    search,
    liveroomSettingLecture,
    liveroomSetting,
    coupon,
    relaySetting,
    relay,
    relayConfirm,
    walletDetail,
    lecturerInvite,
    newCoupon,
    robot,
    schedule,
    details,
    imagePreviewer,
    global_component,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js